import {
  AppBar,
  Toolbar,
  Button,
  Box,
  IconButton,
  Menu,
  MenuItem,
  useScrollTrigger,
  Slide,
  useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { signOut } from "./auth";
import { useState } from "react";

function HideOnScroll({ children }) {
  const trigger = useScrollTrigger();

  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  );
}

function NavBar() {
  const { userLoggedIn, loading: authLoading } = useAuth();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const isMobile = useMediaQuery('(max-width:768px)');

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    signOut();
    handleClose();
    navigate("/");
  };

  const navLinks = authLoading ? [] : userLoggedIn ? [
    { path: "/", label: "Website" },
    { path: "/event-form", label: "Add Event" },
    { path: "/events", label: "Events" },
    { path: "/artist-profiles", label: "Artist Profiles" },
    { label: "Logout", onClick: handleLogout }
  ] : [
    { path: "/#why-nuun", label: "Why NUUN" },
    { path: "/login", label: "Login" },
    { path: "/signup", label: "Become a partner" }
  ];

  return (
    <HideOnScroll>
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          backgroundColor: "#000",
          borderBottom: "1px solid #ffffff24",
          backdropFilter: "none",
          opacity: 1,
        }}
      >
        <Toolbar>
          <Link to="/">
            <img
              alt="logo"
              src={require("../src/assets/FullnuunLogoV2.png")}
              className="navbar-logo"
            />
          </Link>
          <Box sx={{ flexGrow: 1 }} />

          {isMobile ? (
            <>
              <IconButton
                size="large"
                edge="end"
                aria-label="menu"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleMenu}
                sx={{ color: "var(--whiteText-color)" }}
              >
                <MenuIcon />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={open}
                onClose={handleClose}
              >
                {navLinks.map((link) => (
                  <MenuItem
                    key={link.label}
                    onClick={link.onClick || handleClose}
                    component={link.path ? Link : 'div'}
                    to={link.path}
                  >
                    {link.label}
                  </MenuItem>
                ))}
              </Menu>
            </>
          ) : (
            <Box sx={{ display: 'flex', gap: 2 }}>
              {navLinks.map((link) => (
                <Button
                  key={link.label}
                  component={link.path ? Link : 'div'}
                  to={link.path}
                  onClick={link.onClick}
                  disableRipple
                  sx={{ 
                    color: "var(--whiteText-color)",
                    '&:hover': {
                      backgroundColor: 'transparent'
                    }
                  }}
                >
                  {link.label}
                </Button>
              ))}
            </Box>
          )}
        </Toolbar>
      </AppBar>
    </HideOnScroll>
  );
}

export default NavBar;
